import React, { useEffect, useState } from "react";
import { faDownload, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Nav, Navbar } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import InquiryFormModal from "../common_components/InquiryFormModal/InquiryFormModal";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const [expanded, setExpanded] = useState(false);
  const [modalshow, setmodalshow] = useState(false);

  const handleNavClick = (path) => {
    navigate(path);
    setExpanded(false);
  };

  const openModal = () => {
    setmodalshow(true);
    setExpanded(false); // close navbar
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // SCROLL HANDLER
    const section = params.get("section");
    if (section) {
      const el = document.getElementById(section);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
    // MODAL HANDLER
    const modal = params.get("modal");
    if (modal === "contact-us") {
      setmodalshow(true);
    }
  }, [location]);

  return (
    <section className="main_head">
      {/* Top Buttons */}
      <div className="inquirybtndiv">
        <a href="tel:+919607755557" className="inquirybtn">
          <span>
            <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
          </span>
          CALL US
        </a>

        <button className="inquirybtn" onClick={openModal}>
          <span>
            <FontAwesomeIcon icon={faDownload} style={{ color: "#fff" }} />
          </span>
          DOWNLOAD BROCHURE
        </button>
      </div>

      <div className="container-md">
        <Navbar
          expand="md"
          className="main_navbar p-0"
          onToggle={(value) => setExpanded(value)}
          expanded={expanded}
        >
          {/* Logo */}
          <Navbar.Brand>
            <div className="logodiv" onClick={() => handleNavClick("/")}>
              <img
                src="/assets/images/header/logo.png"
                alt="Logo"
                className="logo_img"
              />
            </div>
          </Navbar.Brand>

          {/* Mobile Right Section */}
          <div className="mobile_logo_holder_2">
            <img
              src="/assets/images/header/right-head-logo.png"
              alt="Logo"
              className="logo_img new_logo"
            />

            <div className="number_class">
              <span>
                <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
              </span>
              <a href="tel:+919607755557">+91 9607755557</a>
            </div>
          </div>

          <Navbar.Toggle />

          <Navbar.Collapse>
            <div className="links_holder">
              <div className="links_div">
                <Nav className="nav_links">
                  <Nav.Link
                    onClick={() => handleNavClick("/")}
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => {
                      navigate("/programs");
                      setExpanded(false);
                    }}
                  >
                    Programs
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => {
                      navigate("/admission_process");
                      setExpanded(false);
                    }}
                  >
                    Admissions
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => {
                      navigate("/eligibility-criteria");
                      setExpanded(false);
                    }}
                  >
                    Eligibility
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => {
                      navigate("/fee_structure");
                      setExpanded(false);
                    }}
                  >
                    Fees
                  </Nav.Link>

                  {/* <Nav.Link
                    onClick={() => {
                      window.history.pushState(null, "", "/#contact-us");
                      openModal();
                      setExpanded(false);
                    }}
                  >
                    Contact Us
                  </Nav.Link> */}
                </Nav>
              </div>
            </div>

            {/* Desktop Right Section */}
            <div className="desk_logo_holder_2">
              <img
                src="/assets/images/header/right-head-logo.png"
                alt="Logo"
                className="right_logo"
              />

              <div className="number_class">
                <span>
                  <FontAwesomeIcon icon={faPhone} style={{ color: "#fff" }} />
                </span>
                <a href="tel:+919607755557">+91 9607755557</a>
              </div>

              <div>
                <button className="inquirybtn" onClick={openModal}>
                  <span>
                    <FontAwesomeIcon
                      icon={faDownload}
                      style={{ color: "#fff" }}
                    />
                  </span>
                  DOWNLOAD BROCHURE
                </button>
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </div>

      {/* Modal */}
      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
}

export default Header;
